export default __webpack_public_path__ + "static/media/Microsoft.3bc4aec4.svg";